import * as routers from '@/routers/routePathKey';
import projectIcon from '@/images/navs/project.svg';
import companyIcon from '@/images/navs/company.svg';
import dataIcon from '@/images/navs/data.svg';
import printerIcon from '@/images/navs/printer.svg';
import recordIcon from '@/images/navs/record.svg';
import memberIcon from '@/images/navs/member.svg';
import manageIcon from '@/images/navs/manage.svg';
import i18next from 'i18next';

export interface IRouter {
	path: string; //地址
	name?: string; //菜单名字
	letNav?: boolean; //是否添加到左边导航
	navIcon?: string; //图片
	role: string[]; //权限
	children?: IRouter[];
	key: string;
	tip?: string;
}
export const userProjectRoutes: IRouter[] = [
	{
		name: '项目',
		letNav: true,
		navIcon: projectIcon,
		path: routers.KEY_PATH_PROJECT,
		role: ['0', '1', '2'],
		key: 'project',
		tip: '项目列表',
	},
	{
		name: '成员标准库',
		letNav: true,
		navIcon: memberIcon,
		path: routers.KEY_PATH_STANDARD_LIBRARY,
		role: ['0', '1'],
		key: 'standard',
		tip: '成员标准库列表',
	},
	{
		name: '成员标准库',
		letNav: false,
		navIcon: memberIcon,
		path: routers.KEY_PATH_STANDARD_LIBRARY_DETAIL,
		role: ['0', '1'],
		key: 'standard',
		tip: '成员标准库详情',
	},
	{
		name: '标签标准库',
		letNav: true,
		navIcon: companyIcon,
		path: routers.KEY_PATH_LABEL.KEY_PATH_TAG,
		role: ['0', '1'],
		key: 'tag',
		tip: '标签标准库列表',
		children: [
			{
				name: '专业标签',
				letNav: true,
				path: routers.KEY_PATH_LABEL.KEY_PATH_MAJOR,
				role: ['0', '1'],
				key: 'tag-major',
			},
			{
				name: '团队标签',
				letNav: true,
				path: routers.KEY_PATH_LABEL.KEY_PATH_TEAM,
				role: ['0', '1'],
				key: 'tag-team',
			},
		],
	},
	{
		name: '数据监控',
		letNav: true,
		navIcon: dataIcon,
		path: routers.KEY_PATH_ONLINE,
		role: ['0', '1'],
		key: 'data',
		tip: '数据监控列表',
	},
	{
		name: '接入分端服务器',
		letNav: true,
		navIcon: printerIcon,
		path: routers.KEY_PATH_PRINTER,
		role: ['0', '1'],
		key: 'printer',
		tip: '接入分端服务器列表',
	},
	{
		name: '接入分端服务器详情',
		letNav: false,
		navIcon: printerIcon,
		path: routers.KEY_PATH_PRINTER_DETAIL,
		role: ['0', '1'],
		key: 'tag',
	},
	{
		name: '消息记录',
		letNav: true,
		navIcon: recordIcon,
		path: routers.KEY_PATH_MESSAGE.KEY_PATH_MESSAGE,
		role: ['0', '1'],
		key: 'history',
		tip: '微信消息、短信消息、whatsapp消息列表',
		children: [
			{
				name: i18next.t('msg-history.shortMessage'),
				letNav: true,
				navIcon: companyIcon,
				path: routers.KEY_PATH_MESSAGE.KEY_PATH_MESSAGE_PHONE,
				role: ['0', '1'],
				key: 'short',
			},
			{
				name: i18next.t('msg-history.WeChat'),
				letNav: true,
				navIcon: companyIcon,
				path: routers.KEY_PATH_MESSAGE.KEY_PATH_MESSAGE_WX,
				role: ['0', '1'],
				key: 'WeChat',
			},
			{
				name: 'WHATSAPP',
				letNav: true,
				navIcon: companyIcon,
				path: routers.KEY_PATH_MESSAGE.KEY_PATH_MESSAGE_WHATSAPP,
				role: ['0', '1'],
				key: 'WHATSAPP',
			},
			{
				name: 'LINE',
				letNav: true,
				navIcon: companyIcon,
				path: routers.KEY_PATH_MESSAGE.KEY_PATH_MESSAGE_LINE,
				role: ['0', '1'],
				key: 'LINE',
			},
		],
	},
	{
		name: 'app发布记录',
		letNav: true,
		navIcon: printerIcon,
		path: routers.KEY_PATH_APPVERSION,
		role: ['0', '1'],
		key: 'app',
		tip: 'app发布记录列表',
	},
	{
		name: '同步记录',
		letNav: true,
		navIcon: recordIcon,
		path: routers.KEY_PATH_ASYNC.KEY_PATH_ASYNC_CENTER,
		role: ['0', '1'],
		key: 'async',
		tip: '同步记录列表',
		children: [
			{
				name: '中心向分端同步',
				letNav: true,
				navIcon: companyIcon,
				path: routers.KEY_PATH_ASYNC.KEY_PATH_ASYNC_CENTER,
				role: ['0', '1'],
				key: 'async-center',
			},
			{
				name: '分端向中心同步',
				letNav: true,
				navIcon: companyIcon,
				path: routers.KEY_PATH_ASYNC.KEY_PATH_ASYNC_CLIENT,
				role: ['0', '1'],
				key: 'async-client',
			},
		],
	},
	{
		name: '员工管理',
		letNav: true,
		navIcon: manageIcon,
		path: routers.KEY_PATH_STAFF.KEY_PATH_STAFF,
		role: ['1'],
		key: 'staff-admin',
		tip: '员工管理列表',
		children: [
			{
				name: i18next.t('staff.staff'),
				letNav: true,
				navIcon: companyIcon,
				path: routers.KEY_PATH_STAFF.KEY_PATH_ENABLED_STAFF,
				role: ['1'],
				key: 'staff',
			},
			{
				name: i18next.t('staff.staffDisabled'),
				letNav: true,
				navIcon: companyIcon,
				path: routers.KEY_PATH_STAFF.KEY_PATH_DISABLED_STAFF,
				role: ['1'],
				key: 'staffDisabled',
			},
		],
	},
	// {
	// 	name: 'UI',
	// 	letNav: true,
	// 	navIcon: memberIcon,
	// 	path: routers.KEY_PATH_UI,
	// 	role: ['0', '1', '2'],
	// },
];

export default routers;
